import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Lottie from 'react-lottie';

import Modal from '../common/Modal';
import { FlyInTransition } from '../../components/transitions/transitions';

import offlineLottie from '../../../src/images/crosswordImages/offline_lottie.json';
import CloseCircleIcon from '../../images/lab-test/closeCircleIconSvg';

function UploadPrescriptionModal({ data, showModal, closeModal }) {
  console.log(data, '[data]');
  const [countdown, setCountdown] = useState(10);
  const history = useHistory();

  useEffect(() => {
    let timer;

    if (showModal && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }

    return () => {
      clearInterval(timer);
    };
  }, [showModal, countdown]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: offlineLottie,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const handleNavigation = () => {
    history.push('/consultation/appointment/appointment-status', {
      requestId: data.pendingRequestId,
      goBack: true,
    });
  };

  return (
    <Modal showModal={showModal}>
      <div className="modalContainer">
        <FlyInTransition in={showModal} mountOnEnter unmountOnExit appear>
          <div
            className="flex flex-col items-center justify-center bg-textbox rounded-12 p-20 "
            style={{ width: '85%', maxWidth: '400px' }}
          >
            <div className="w-100 flex justify-end">
              <button
                className="flex justify-center p-1 rounded-full bg-customEBEAF5"
                onClick={closeModal}
                disabled={countdown > 0}
              >
                {countdown > 0 ? (
                  <span className="text-chip mx-1">{countdown} Sec</span>
                ) : (
                  <></>
                )}
                <CloseCircleIcon />
              </button>
            </div>
            <div>
              <div>
                <Lottie
                  options={defaultOptions}
                  height={120}
                  width={120}
                ></Lottie>
              </div>
              <div className="text-[#131836] text-center font-mont font-bold text-title-m leading-[120%] mb-10">
                <p>Upload Prescription</p>
              </div>
              <div className=" text-center mb-20 text-body-s w-72 m-auto">
                Upload your prescription from your recent consultation with{' '}
                <strong>{data.doctorName}</strong>
              </div>
              <div className="inline-flex p-2 space-x-2 items-start rounded-xl bg-backGroundLightPrimaryColor">
                <div className=" font-small text-center px-1 text-card-body  w-full">
                  Your Visit App will be restricted until you upload your
                  prescription.
                </div>
              </div>
            </div>
            <button
              className=" text-txtlight bg-primary font-semibold w-full p-10 rounded-lg mt-30 text-body-s"
              onClick={handleNavigation}
            >
              Upload Prescription
            </button>
          </div>
        </FlyInTransition>
      </div>
    </Modal>
  );
}

export default UploadPrescriptionModal;
